import { Divider, List, ListSubheader } from '@mui/material';

import { AnchorMenuItem } from './AnchorMenuItem';
import { useMenuStyles } from './Menu.styles';
import { MenuItem } from './Menu.types';
import { PopupMenu } from './PopupMenu';
import { SideMenuItem } from './SideMenuItem';

export type MenuProps = {
  /** The items displayed in the menu. */
  items?: Array<MenuItem>;

  /** The layout of the menu.
   *
   * - *header* layout displays items in a row and is intended for menus
   *   displayed in the topmost part of the page.
   * - *side* layout displays items in a column and is intended for menus
   *   displayed in the left or right side of the page
   * - *popup* layout displays a single button
   */
  layout?: '' | 'header' | 'popup' | 'side';

  /** Defines if the menu should take 100% of the horizontal space available.
   * Applicable for 'header' layout.
   */
  stretched?: boolean;
};

export const Menu = ({ items = [], layout = 'side', stretched = false }: MenuProps) => {
  const classes = useMenuStyles();

  switch (layout) {
    case 'header':
      return (
        <List className={classes.headerMenu}>
          {items.map((item, index) => {
            const key = item.text + index;
            return item.divider ? (
              <Divider flexItem key={key} orientation="vertical" />
            ) : (
              <AnchorMenuItem
                arrow="down"
                item={item}
                key={key}
                popupPlacement="bottom"
                stretched={stretched}
              />
            );
          })}
        </List>
      );
    case 'popup':
      return <PopupMenu items={items} />;
    case 'side':
    default:
      return (
        <List className={classes.leftMenu}>
          {items.map((item, index) => {
            const key = item.text + index;
            return item.divider ? (
              <Divider key={key} />
            ) : item.subHeader ? (
              <ListSubheader key={key} id={key} className={classes.subHeader}>
                {item.text}
              </ListSubheader>
            ) : (
              <SideMenuItem item={item} key={key} />
            );
          })}
        </List>
      );
  }
};
